<template>
  <v-container class="mt-5 ml-2" fluid v-if="[1,334,568,2268,169,3,2910,1312,1177].includes(getdatosUsuarioERPERP.iderp) || getdatosUsuarioERPERP.idpuesto == 82">
    <v-row>
      <v-col cols="12">

      	<v-card class="shadowCard">
      	  <v-card-title class="text-subtitle-1">
      	    Planeación de grupos
      	    <v-spacer></v-spacer>

      	    <!-- Boton para mostrar los salones en los horarios requeridos -->
      	    <v-btn 
              class="mr-2" 
              dark
              outlined
              color="orange"
              @click="dialogReporteSalones = true"
            >
              <v-icon small>mdi-google-classroom</v-icon>
            </v-btn>

      	    <!-- Botón modal turnos (matutino/vespertino) -->
      	    <v-btn 
              class="mr-2" 
              dark
              outlined
              color="blue"
              @click="dialogTurnos = true"
            >
              <v-icon small>mdi-clock-outline</v-icon>
            </v-btn>

      	    <v-btn 
              class="mr-2" 
              dark
              outlined
              color="green"
              @click="exportExcel( cursoserp  , 'planeacion_grupo')"
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              outlined
              class="text-capitalize"
              @click="consultar()"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

      	  </v-card-title>

      	  <!-- Tabla y filtros -->
      	  <v-card-text>

      	  	<!-- Filtro de ciclos -->
      	    <v-row>
              <v-col cols="12" sm="6" lg="4" xl="3">

              	<v-chip-group
					        v-model="escuela"
					        active-class="deep-purple--text text--accent-4"
					        mandatory
					        large
					      >
					        <v-chip class="px-6"><b>INBI</b></v-chip>
					        <v-chip class="px-6"><b>FAST</b></v-chip>
					        <!-- <v-chip class="px-6"><b>TODO</b></v-chip> -->
					      </v-chip-group>
              </v-col>
            </v-row>

            <!-- Check para los eliminados y optimizados -->
            <v-row>
              <v-col cols="12" sm="6" lg="3" xl="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  persistent-hint
                  single-line
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                >
                </v-autocomplete>
              </v-col>
              <!-- Seleccionar un plantel -->
              <v-col cols="12" sm="6" lg="3" xl="3">
						    <v-autocomplete
						    	filled
						      :items="filterPlanteles"
						      v-model="plantel"
						      label="Plantel"
						      clearable
						      dense
						      item-text="plantel"
						      item-value="idplantel"
                  single-line
						    ></v-autocomplete>
            	</v-col>

            	<!-- Seleccionar un nivel -->
              <v-col cols="12" sm="6" lg="3" xl="3">
              	<v-switch label="Sin calavera" v-model="sinCalavera"></v-switch>
						    <!-- <v-autocomplete
						    	filled
						      :items="niveles"
						      v-model="nivel"
						      label="Nivel"
						      clearable
						      dense
                  single-line
						    ></v-autocomplete> -->
            	</v-col>

            	<!-- Seleccionar un horario -->
              <v-col cols="12" sm="6" lg="3" xl="3">
						    <v-autocomplete
						    	filled
						      :items="horariosFiltro"
						      v-model="horario"
						      label="Horario"
						      item-text="horario"
						      item-value="horario"
						      clearable
						      dense
                  single-line
						    ></v-autocomplete>
            	</v-col>

            </v-row>

            

            <!-- Mostrar información por bloques -->
            <v-row>

            	<v-col cols="12" md="6" lg="3">
              	<v-icon left color="yellow" class="mr-1">mdi-triangle</v-icon>Menos de 5 alumnos inscritos<br/>
	        			<v-icon left color="grey"   class="mr-1">mdi-human-child</v-icon>Grupo de teens<br/>
	        			<v-icon left color="yellow" class="mr-1">mdi-label</v-icon>Grupo de relleno<br/>
	        			<v-icon left color="yellow" class="mr-1">mdi-stop-circle</v-icon>Su grupo siguiente es certificación<br/>
	        			<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2"></v-img>Grupo a cerrar<br/>
              </v-col>


            	<v-col cols="12" md="6" lg="3">
              	<v-chip-group
					        v-model="opDia"
					        active-class="deep-purple--text text--accent-4"
					        mandatory
					      >
					        <v-chip class="px-6"><b>L - V</b></v-chip>
					        <v-chip class="px-6"><b>S</b></v-chip>
					        <v-chip class="px-6"><b>D</b></v-chip>
					      </v-chip-group>
              </v-col>

              <v-col cols="12" md="6" lg="2" v-if="gruposSeleccionados.length">
              	<v-btn color="success" @click="dialogGrupos = true"> Seleccionados: {{ gruposSeleccionados.length }} </v-btn>
              </v-col>

              <v-col cols="12" md="2" lg="2">
              	<div class="text-h5">
              		Salones: {{ kpiPlaneacion.salonesOcupados }}/{{ kpiPlaneacion.salonesTotal }}<br/>
              		Grupos:  {{ kpiPlaneacion.grupos }}
              	</div>
              </v-col>

              <v-col cols="12" md="6" lg="4">
                <v-text-field
                  v-model="search"
                  label="Búscar"
                  dense
                  filled
                  hide-details
                  single-line
                  clearable
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
            	<v-col cols="12">

				        <!-- Tabla con toda la información -->
				        <v-data-table
				          :headers="headersGrupos"
				          :items="filterRangos"
				          class="elevation-0"
				          dense
				          :search="search"
				          multi-sort
				          :loading="cargar"
				          hide-default-footer
				          :items-per-page="filterRangos.length"
              		id="clasesGrupos"
				        >
				        	<template v-slot:item.lu11_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu11_n"
				        				:key="i"
				        				v-if="i == 0 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        			<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu1_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu11_n, 0)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu1' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu12_n="{ item }">
				        		<div class="cell-full">
					        		<v-chip 
				        				v-for="(salon, i) in item.lu12_n"
				        				:key="i"
				        				v-if="i == 1 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        			<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>

					        		<v-chip 
					        			v-for="(salon, j) in item.lu2_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu12_n, 1)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			:dark="salon.grupos.length ? true : false "
					        			@click="toggleSalonSelect(salon, item, 'lu2' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.lu13_n="{ item }">
				        		<div class="cell-full">
					        		<v-chip 
				        				v-for="(salon, i) in item.lu13_n"
				        				:key="i"
				        				v-if="i == 2 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        			<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>

					        		<v-chip 
					        			v-for="(salon, j) in item.lu3_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu13_n, 2)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			:dark="salon.grupos.length ? true : false "
					        			@click="toggleSalonSelect(salon, item, 'lu3' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.lu14_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu14_n"
				        				:key="i"
				        				v-if="i == 3 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        			<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu4_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu14_n, 3)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu4' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu15_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu15_n"
				        				:key="i"
				        				v-if="i == 4 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu5_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu15_n, 4)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu5' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu16_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu16_n"
				        				:key="i"
				        				v-if="i == 5 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu6_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu16_n, 5)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu6' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu18_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu18_n"
				        				:key="i"
				        				v-if="i == 7 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu8_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu18_n, 7)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu8' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu19_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu19_n"
				        				:key="i"
				        				v-if="i == 8 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu9_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu19_n, 8)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu9' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu110_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu110_n"
				        				:key="i"
				        				v-if="i == 9 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu10_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu110_n, 9)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu10' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu111_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu111_n"
				        				:key="i"
				        				v-if="i == 10 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu11_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu111_n, 10)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu11' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu112_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu112_n"
				        				:key="i"
				        				v-if="i == 11 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu12_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu112_n, 11)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu12' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu113_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu113_n"
				        				:key="i"
				        				v-if="i == 12 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu13_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu113_n, 12)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu13' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu114_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu114_n"
				        				:key="i"
				        				v-if="i == 13 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu14_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu114_n, 13)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu14' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.lu17_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.lu17_n"
				        				:key="i"
				        				v-if="i == 6 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.lu7_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.lu17_n, 6)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'lu7' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.ma11_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.ma11_n"
				        				:key="i"
				        				v-if="i == 0 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		<v-chip 
					        			v-for="(salon, j) in item.ma1_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.ma11_n, 0)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'ma1' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.ma12_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.ma12_n"
				        				:key="i"
				        				v-if="i == 1 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>

					        		<v-chip 
					        			v-for="(salon, j) in item.ma2_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.ma12_n, 1)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'ma2' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.ma13_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.ma13_n"
				        				:key="i"
				        				v-if="i == 2 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		
					        		<v-chip 
					        			v-for="(salon, j) in item.ma3_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.ma13_n, 2)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'ma3' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.ma14_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.ma14_n"
				        				:key="i"
				        				v-if="i == 3 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>
					        			<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
					        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
					        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
					        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
					        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
					        		</v-chip>
					        		
					        		<v-chip 
					        			v-for="(salon, j) in item.ma4_x"
					        			:key="j"
					        			class="ma-2"
					        			v-if="!item.inicio.match(':30') && salonLibreEnColumna(salon, item.ma14_n, 3)"
					        			:color="salon.selected ? 'yellow' : 'grey lighten-3' "
					        			@click="toggleSalonSelect(salon, item, 'ma4' )"
					        		>{{ salon.name_salon }} - -  0/ {{ salon.capacidad }}</v-chip>
					        		
					        	</div>
				          </template>

				          <template v-slot:item.mi11_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.mi11_n"
				        				:key="i"
				        				v-if="i == 0 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.mi12_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.mi12_n"
				        				:key="i"
				        				v-if="i == 1 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.mi13_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.mi13_n"
				        				:key="i"
				        				v-if="i == 2 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.ju11_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.ju11_n"
				        				:key="i"
				        				v-if="i == 0 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.ju12_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.ju12_n"
				        				:key="i"
				        				v-if="i == 1 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.ju13_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.ju13_n"
				        				:key="i"
				        				v-if="i == 2 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.vi11_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.vi11_n"
				        				:key="i"
				        				v-if="i == 0 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.vi12_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.vi12_n"
				        				:key="i"
				        				v-if="i == 1 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.vi13_n="{ item }" class="pa-0">
				        		<div class="cell-full">
					        		<v-chip 
					        			block
				        				v-for="(salon, i) in item.vi13_n"
				        				:key="i"
				        				v-if="i == 2 && salon.grupos.length"
				        				width="100px"
				        				class="chip-fill"
					        			label
					        			:color="salon.color"
					        			@click="cerrarGrupo( salon, i )"
					        			:dark="salon.grupos.length ? true : false "
					        		>{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}</v-chip>
					        	</div>
				          </template>

				          <template v-slot:item.sa1_n="{ item }">
				        		<div class="chips-container">
									    <template v-for="(salon, i) in item.sa1_n">
									      <v-chip
									      	v-if="salon.grupos.length"
					        				:key="'sa-' + (salon.id_salon || i)"
					        				:color="salon.color"
					        				:dark="true"
					        				@click="cerrarGrupo( salon, i )"
									    		class="full-chip"
									      >
									        <v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
						        			<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
						        			<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
						        			<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
						        			<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
					        				{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
									      </v-chip>
									      <span v-else :key="'sa-vacio-' + (salon.id_salon || i)" class="salon-slot-vacio"></span>
									    </template>
									  </div>

				          </template>

				          <template v-slot:item.do1_n="{ item }">
				        		<div class="chips-container">
					        		<template v-for="(salon, i) in item.do1_n">
						        		<v-chip
						        			v-if="salon.grupos.length"
						        			:key="'do-' + (salon.id_salon || i)"
						        			:color="salon.color"
						        			:dark="true"
						        			@click="cerrarGrupo( salon, i )"
									    		class="full-chip"
						        		>
							        		<v-icon v-if="salon.bajo_alumnaje" color="yellow" class="mr-1">mdi-triangle</v-icon>
							        		<v-icon v-if="salon.relleno" color="yellow" class="mr-1">mdi-label</v-icon>
							        		<v-icon v-if="salon.teens" color="white" class="mr-1">mdi-human-child</v-icon>
							        		<v-icon v-if="salon.grupos ? salon.gruposCompletos[0].certi : false" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
							        		<v-img src="@/assets/iconos/cerrado.png" width="30" class="mr-2" v-if="salon.grupos ? salon.gruposCompletos[0].cerrado : false"></v-img>
						        			{{ salon.name_salon }} - {{ salon.grupos.join(',').replace('NIVEL','L').replace('Nivel','L') }} - {{ salon.alumnos.join(',') }}/{{ salon.capacidad }}
						        		</v-chip>
						        		<span v-else :key="'do-vacio-' + (salon.id_salon || i)" class="salon-slot-vacio"></span>
						        	</template>
					        	</div>
				          </template>

				        </v-data-table>
            	</v-col>
            </v-row>


      	  </v-card-text>
      	</v-card>

      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogGrupos"
      persistent
      max-width="1200px"
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
		      <GruposMultiples  
		      	ref="gruposMultiples"
		      	:idciclo="ciclo"
						:plantel="plantel" 
						:editedItem="editedItem" 
						:gruposSeleccionados="gruposSeleccionados"
						:gruposOcupacion="grupos"
						:horariosCatalog="horariosCatalog"
						@saved="onGruposGuardados"
						@click="consultar()"
					/> 
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogGrupos = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            dark
            :disabled="!gruposSeleccionados.length"
            @click="guardarGruposPlaneacion"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- grupoACerrar
		dialoCerrar -->

		<v-dialog
      v-model="dialoCerrar"
      persistent
      max-width="480px"
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-img src="@/assets/iconos/cerrar.png" width="45"></v-img>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text v-if="grupoACerrar" class="text-h6 text-center black--text" text="center" >
		      {{ grupoACerrar.grupo }}

		      <v-autocomplete
		      	v-model="grupoACerrar.id_salon"
		      	:items="salonesGrupoCerrar"
		      	label="Salón"
		      	item-text="salon_label"
		      	item-value="id_salon"
		      	outlined
		      	dense
		      	hide-details
		      	class="mt-4"
		      ></v-autocomplete>

		      <div class="text-center mt-4" align="center">
		      	<v-switch label="¿Grupo cerrado?" v-model="grupoACerrar.cerrado"></v-switch>
		      </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        	<v-btn
            color="red"
            dark
            class="mr-2"
            @click="dialoCerrar = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green"
            dark
            @click="confirmarCierre( )"
          >
            Guardar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGO DE REPORTE DE GRUPOS -->
    <v-dialog
      v-model="dialogReporteSalones"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          <v-icon color="orange" left>mdi-google-classroom</v-icon>
          Mini reporte 
        </v-card-title>
        <v-card-text>
          <v-data-table
				    dense
				    :headers="headersMiniReporte"
				    :items="dataMiniReporte"
				    item-key="name"
				    class="elevation-0"
				    hide-default-footer
				  >
				  	<template v-slot:item.teens="{ item }">
				  		{{ item.teens }}
				      <v-icon
				        small
				        right
				        class="mr-2"
				        :color="item.teens > 0 ? 'green' : 'red'"
				      	v-text="item.teens > 0 ? 'mdi-check' : 'mdi-close' "
				      >
				      </v-icon>
				    </template>

				    <template v-slot:item.adultos="{ item }">
				    	{{ item.adultos }}
				      <v-icon
				        small
				        right
				        class="mr-2"
				        :color="item.adultos > 0 ? 'green' : 'red'"
				      	v-text="item.adultos > 0 ? 'mdi-check' : 'mdi-close' "
				      >
				      </v-icon>
				    </template>

				  </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn 
          	color="black"
          	absolute
          	top
          	right
          	@click="dialogReporteSalones = false"
          	icon
          >
        		<v-icon>mdi-close</v-icon>
        	</v-btn>
        </v-card-actions>
      </v-card>				
    </v-dialog>

    <!-- Modal de turnos (matutino/vespertino) -->
    <v-dialog
      v-model="dialogTurnos"
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          <v-icon color="blue" left>mdi-clock-outline</v-icon>
          Reporte por turno
        </v-card-title>
        <v-card-text>
          <v-data-table
            dense
            :headers="headersTablaTurnos"
            :items="dataTablaTurnos"
            item-key="turno"
            class="elevation-0"
            hide-default-footer
          >
            <template v-slot:item.vacantes="{ item }">
              <v-menu offset-y close-on-click>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    small
                    class="cursor-pointer"
                  >
                    {{ item.ocupadas }}
                    <v-icon right small>mdi-chevron-down</v-icon>
                  </v-chip>
                </template>
                <v-list dense max-height="300" class="overflow-y-auto">
                  <v-subheader>Desglose ({{ item.desglose.length }} grupos)</v-subheader>
                  <v-list-item
                    v-for="(g, idx) in item.desglose"
                    :key="g.id_grupo || idx"
                    dense
                  >
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2">
                        {{ g.grupo }} · {{ g.name_salon || g.salon }} · {{ g.alumnos }}/{{ g.capacidad }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!item.desglose.length">
                    <v-list-item-content>
                      <v-list-item-title class="text-caption grey--text">Sin grupos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            absolute
            top
            right
            @click="dialogTurnos = false"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import filtrosRolTeachers    from '@/mixins/filtrosRolTeachers'
  import salonesDisponibles    from '@/mixins/salonesDisponibles'
  import GruposMultiples       from '@/components/grupos/GruposMultiples.vue';

	var moment = require('moment');
  moment.locale();

  export default {

  	components:{
      Alerta,
      carga,
      GruposMultiples
    },

    mixins: [ validarErrores, funcionesExcel, filtrosRolTeachers, salonesDisponibles ],

    data: () => ({

    	itemsT : [
			  { id: 1, dia: 'L', hora: '18:00', salon: 7, label: 'S9 · L14 · 4/24', color: 'teal' },
			  { id: 2, dia: 'L', hora: '18:00', salon: 7, label: 'S5 · L5',        color: 'blue' },
			  { id: 3, dia: 'L', hora: '18:00', salon: 7, label: 'S14 · L3 · 12/24', color: 'brown' }
			],


			dias: ['lu','ma','mi','ju','vi'],
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      search:'',
      gruposRoles: [],
      ciclos:[],
      ciclo:null,

      // Filtros avanzados
      niveles:[],
      nivel: null,

      planteles: [],
      plantel: null,
      plantelRol: null,

      horarios:[],
      horariosCatalog:[],
      horario: null,

      modalidades:[],
      modalidad:null,

			escuela:0,

			horario: null,

			dialogGrupos: false,

			salones:[],

		 	fecha_hoy: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

		 	rangos: [],

		 	grupos:[],

		 	opDia: 0,

    	tabs: 0, 

    	 // una fila por cada intervalo de 30min
	    rows: [
	      { id: 1, hora: '09:00', salon: 7, chips: [{ id: 'a', label: 'S3 - L2 - 9/24' }] },
	      { id: 2, hora: '09:30', salon: 7, chips: [{ id: 'b', label: 'S3 - L2 - 9/24' }] },
	      { id: 3, hora: '10:00', salon: 7, chips: [] },
	    ],
	    BLOCK_MIN: 60, // queremos unir 09:00 y 09:30 en un bloque de 60 min

		 	editedItem: {
        id_grupo:0,
				forma_pago:'',
				comentarios:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
      },

      dialogGrupos: false,

      gruposSeleccionados: [],

      grupoACerrar: null,
			salonCierreOriginal: null,
			dialoCerrar: false,
			dialogReporteSalones: false,
			dialogTurnos: false,

			headersTablaTurnos: [
				{ text: 'Turno', value: 'turno', sortable: false },
				{ text: 'Horario', value: 'horario', sortable: false },
				{ text: 'Vacantes ocupadas', value: 'vacantes', sortable: false, align: 'center' },
			],

			headersMiniReporte:[
				{ text: 'Horario'        , value: 'horario'   },
	      { text: 'Teens'          , value: 'teens'     },
	      { text: 'Adultos'        , value: 'adultos'   },
			],

			sinCalavera: false,

			gruposHorario: 0,
	  }),

    computed:{

    	dataMiniReporte( ){

    		let data = []

    		let gruposTeensM  = this.grupos.filter( el => !el.cerrado && el.id_plantel == this.plantel && el.hora_fin <= "14:00:00" && el.grupo.match('TEENS') && [1,4,7].includes( el.id_nivel ))
    		let gruposTeensV  = this.grupos.filter( el => !el.cerrado && el.id_plantel == this.plantel && el.hora_fin >  "14:00:00" && el.grupo.match('TEENS') && [1,4,7].includes( el.id_nivel ))
    		let gruposAdultsM = this.grupos.filter( el => !el.cerrado && el.id_plantel == this.plantel && el.hora_fin <= "14:00:00" && !el.grupo.match('TEENS') && [1,4,7].includes( el.id_nivel ))
    		let gruposAdultsV = this.grupos.filter( el => !el.cerrado && el.id_plantel == this.plantel && el.hora_fin >  "14:00:00" && !el.grupo.match('TEENS') && [1,4,7].includes( el.id_nivel ))

    		if( this.opDia == 0 ){
	    		gruposTeensM  = gruposTeensM.filter( el => el.lunes || el.martes || el.miercoles || el.jueves || el.viernes) 
	    		gruposTeensV  = gruposTeensV.filter( el => el.lunes || el.martes || el.miercoles || el.jueves || el.viernes) 
	    		gruposAdultsM = gruposAdultsM.filter( el => el.lunes || el.martes || el.miercoles || el.jueves || el.viernes) 
	    		gruposAdultsV = gruposAdultsV.filter( el => el.lunes || el.martes || el.miercoles || el.jueves || el.viernes) 
    		}

    		if( this.opDia == 1 ){
	    		gruposTeensM  = gruposTeensM.filter( el => el.sabado ) 
	    		gruposTeensV  = gruposTeensV.filter( el => el.sabado ) 
	    		gruposAdultsM = gruposAdultsM.filter( el => el.sabado ) 
	    		gruposAdultsV = gruposAdultsV.filter( el => el.sabado ) 
    		}

    		if( this.opDia == 2 ){
	    		gruposTeensM  = gruposTeensM.filter( el => el.domingo ) 
	    		gruposTeensV  = gruposTeensV.filter( el => el.domingo ) 
	    		gruposAdultsM = gruposAdultsM.filter( el => el.domingo ) 
	    		gruposAdultsV = gruposAdultsV.filter( el => el.domingo ) 
    		}

    		data.push({
    			horario: 'Matutino',
    			teens: gruposTeensM.length,
    			adultos: gruposAdultsM.length
    		})

    		data.push({
    			horario: 'Vespertino',
    			teens: gruposTeensV.length,
    			adultos: gruposAdultsV.length
    		})

    		return data

    	},

    	dataTablaTurnos() {
    		// Solo LUNES por ahora (opDia 0). Por columna: lu11_n=índice 0, lu12_n=índice 1... La columna tiene color si array.length > índice.
    		const toMin = (t) => {
    			if (!t) return 0
    			const str = String(t)
    			const parts = str.split(':').map(Number)
    			const hh = parts[0] || 0
    			const mm = parts[1] || 0
    			return hh * 60 + mm
    		}

    		const getLuColIndex = (value) => {
    			const m = value.match(/^lu1(\d+)_n$/)
    			if (!m) return -1
    			const num = parseInt(m[1], 10)
    			if (num <= 19) return num - 11
    			return num - 101
    		}

    		if (!this.plantel) {
    			return [
    				{ turno: 'Matutino', horario: '8:00 - 12:00', ocupadas: 0, desglose: [] },
    				{ turno: 'Vespertino', horario: '1:00 PM - 10:00 PM', ocupadas: 0, desglose: [] },
    			]
    		}

    		const columnKeys = this.headersGrupos
    			.filter(h => h.value !== 'label' && /^lu1\d+_n$/.test(h.value))
    			.map(h => h.value)

    		const matutinoColumnas = new Set()
    		const vespertinoColumnas = new Set()
    		const matutinoGrupos = new Map()
    		const vespertinoGrupos = new Map()
    		const rangos = this.filterRangos || []

    		for (const key of columnKeys) {
    			const colIndex = getLuColIndex(key)
    			if (colIndex < 0) continue

    			for (const rango of rangos) {
    				const inicio = rango.inicio
    				const h = toMin(inicio)
    				const esMatutino = h >= 480 && h < 720
    				const esVespertino = h >= 780 && h <= 1320

    				const salones = rango[key] || []
    				const salonAtIdx = salones[colIndex]
    				const hasGrupos = (s) => (s && ((s.grupos && s.grupos.length) || (s.gruposCompletos && s.gruposCompletos.length)))
    				const tieneColor = salones.length > colIndex && hasGrupos(salonAtIdx)

    				if (!tieneColor) continue

    				const salonForDesglose = salonAtIdx
    				if (esMatutino) {
    					matutinoColumnas.add(key)
    					if (salonForDesglose && salonForDesglose.gruposCompletos) {
    						for (const g of salonForDesglose.gruposCompletos) {
    							matutinoGrupos.set(g.id_grupo, { ...g, name_salon: salonForDesglose.name_salon || salonForDesglose.salon })
    						}
    					}
    				}
    				if (esVespertino) {
    					vespertinoColumnas.add(key)
    					if (salonForDesglose && salonForDesglose.gruposCompletos) {
    						for (const g of salonForDesglose.gruposCompletos) {
    							vespertinoGrupos.set(g.id_grupo, { ...g, name_salon: salonForDesglose.name_salon || salonForDesglose.salon })
    						}
    					}
    				}
    			}
    		}

    		const desgloseMatutino = Array.from(matutinoGrupos.values())
    		const desgloseVespertino = Array.from(vespertinoGrupos.values())

    		return [
    			{ turno: 'Matutino', horario: '8:00 - 12:00', ocupadas: matutinoColumnas.size, desglose: desgloseMatutino },
    			{ turno: 'Vespertino', horario: '1:00 PM - 10:00 PM', ocupadas: vespertinoColumnas.size, desglose: desgloseVespertino },
    		]
    	},

    	sorted () {
	      const toMin = t => {
	        const [h, m] = t.split(':').map(Number)
	        return h * 60 + m
	      }
	      return [...this.rows].sort((a, b) => toMin(a.hora) - toMin(b.hora))
	    },

	    layout () {
	      const toMin = t => {
	        const [h, m] = t.split(':').map(Number)
	        return h * 60 + m
	      }

	      const blockKey = r => {
	        const m = toMin(r.hora)
	        const b = Math.floor(m / this.BLOCK_MIN) * this.BLOCK_MIN // 09:00 y 09:30 => 09:00
	        let campo = `'${r.salon}|${b}'`
	        return campo
	      }

	      const span = Array(this.sorted.length).fill(0)
	      const chipsForIndex = {}
	      let i = 0
	      while (i < this.sorted.length) {
	        const k = blockKey(this.sorted[i])
	        let j = i
	        let chips = []
	        while (j < this.sorted.length && blockKey(this.sorted[j]) === k) {
	          chips = chips.concat(this.sorted[j].chips || [])
	          j++
	        }
	        span[i] = j - i              // cuántas filas abarca el bloque
	        chipsForIndex[i] = chips     // chips combinadas del bloque
	        i = j
	      }
	      return { span, chipsForIndex }
	    },

      ...mapGetters('login',['getdatosUsuarioERPERP']),

      soloLecturaPlaneacion () {
        const usuario = this.getdatosUsuarioERPERP
        if (usuario && Number(usuario.iderp) === 1177) return false
        return usuario && usuario.idpuesto == 82
      },

      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Grupo' : 'Editar Grupo'
      },

      headers2( ){
      	return [
		      { text: 'rango'       , value: 'rango'       },
		      { text: 'Lunes'       , value: 'lu'      },
		      { text: 'Lunes P2'    , value: 'ma'         },
		      { text: 'Lunes P3'    , value: 'mi'       },

				]
      },

      headersGrupos( ){

      	let dataTable = [
		      { text: 'Horario'    , value: 'label'       },
		      // { text: 'Inicio'     , value: 'inicio'      },
		      // { text: 'Final'      , value: 'fin'         },
		      // { text: 'Lunes'      , value: 'lu1_n'       },
		      // { text: 'Martes'     , value: 'ma1_n'       },
		      // { text: 'Miércoles'  , value: 'mi1_n'       },
		      // { text: 'Jueves'     , value: 'ju1_n'       },
		      // { text: 'Viernes'    , value: 'vi1_n'       }

				]

				switch( this.opDia ){

					case 0:
						dataTable.push({ text: 'Lunes'      , value: 'lu11_n'       })
						dataTable.push({ text: 'Lunes'      , value: 'lu12_n'       })
						dataTable.push({ text: 'Lunes'      , value: 'lu13_n'       })
						dataTable.push({ text: 'Lunes'      , value: 'lu14_n'       })
						dataTable.push({ text: 'Lunes'      , value: 'lu15_n'       })
		        
		        if( [16,17,'16','17'].includes( this.plantel ) ){
							// dataTable.push({ text: 'Lunes'      , value: 'lu15_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu16_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu17_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu18_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu19_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu110_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu111_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu112_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu113_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu114_n'       })
		        }else if( [14,'14'].includes( this.plantel ) ){
							// FAST_UNI (ticket 78453): 12 salones. lu11..lu15 ya están arriba;
							// lu16..lu112 cubren los salones 6 a 12. El martes se conserva.
							dataTable.push({ text: 'Lunes'      , value: 'lu16_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu17_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu18_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu19_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu110_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu111_n'       })
							dataTable.push({ text: 'Lunes'      , value: 'lu112_n'       })
							dataTable.push({ text: 'Martes'     , value: 'ma11_n'       })
							dataTable.push({ text: 'Martes'     , value: 'ma12_n'       })
							dataTable.push({ text: 'Martes'     , value: 'ma13_n'       })
							dataTable.push({ text: 'Martes'     , value: 'ma14_n'       })
		        }else{
							dataTable.push({ text: 'Martes'     , value: 'ma11_n'       })
							dataTable.push({ text: 'Martes'     , value: 'ma12_n'       })
							dataTable.push({ text: 'Martes'     , value: 'ma13_n'       })
							dataTable.push({ text: 'Martes'     , value: 'ma14_n'       })
		        }

					break;

					case 1:
						dataTable.push({ text: 'Sábado'      , value: 'sa1_n'       })
					break;

					case 2:
						dataTable.push({ text: 'Domingo'      , value: 'do1_n'       })
					break;
				}



				return dataTable

      },

      filterGrupos ( ){
      	let newGrupos = this.sinCalavera ? this.grupos.filter( el => !el.cerrado ) : this.grupos

			  switch( this.opDia ){

					case 0:
						newGrupos = newGrupos.filter(el => {
							const g = this.normalizarGrupoDias(el)
							return el.id_plantel == this.plantel && !g.sabado && !g.domingo
						})
					break;

					case 1:
						newGrupos = newGrupos.filter(el => {
							const g = this.normalizarGrupoDias(el)
							return el.id_plantel == this.plantel && g.sabado
						})
					break;

					case 2:
						newGrupos = newGrupos.filter(el => {
							const g = this.normalizarGrupoDias(el)
							return el.id_plantel == this.plantel && g.domingo
						})
					break;
				}

				if (this.horario) {
					newGrupos = newGrupos.filter(el => el.horario == this.horario)
				}

				return newGrupos.sort((a, b) => a.grupo.localeCompare(b.grupo))

      },

      horariosFiltro () {
      	let base = this.sinCalavera ? this.grupos.filter(el => !el.cerrado) : this.grupos
      	switch (this.opDia) {
      		case 0:
      			base = base.filter(el => el.id_plantel == this.plantel && !el.sabado && !el.domingo)
      			break
      		case 1:
      			base = base.filter(el => el.id_plantel == this.plantel && el.sabado)
      			break
      		case 2:
      			base = base.filter(el => el.id_plantel == this.plantel && el.domingo)
      			break
      		default:
      			base = base.filter(el => el.id_plantel == this.plantel)
      	}
      	const map = new Map()
      	for (const g of base) {
      		if (g.horario) {
      			map.set(g.horario, { horario: g.horario })
      		}
      	}
      	return Array.from(map.values()).sort((a, b) => a.horario.localeCompare(b.horario))
      },

      kpiPlaneacion () {
      	const grupos = this.filterGrupos
      	const idsSalonesPlantel = new Set(this.filterSalones.map(s => s.id_salon))
      	const ocupados = new Set()

      	for (const g of grupos) {
      		if (g.id_salon && idsSalonesPlantel.has(g.id_salon)) {
      			ocupados.add(g.id_salon)
      		}
      	}

      	return {
      		grupos: grupos.length,
      		salonesTotal: this.filterSalones.length,
      		salonesOcupados: ocupados.size
      	}
      },

      salonesGrupoCerrar () {
      	if (!this.grupoACerrar) {
      		return []
      	}
      	const g = this.grupoACerrar
      	const catalog = this.horariosCatalog || []
      	const h = catalog.find(x => x.id_horario == g.id_horario)
      	const grupoRef = {
      		...g,
      		hora_inicio: g.hora_inicio || (h && h.hora_inicio),
      		hora_fin: g.hora_fin || (h && h.hora_fin)
      	}
      	const idCiclo = g.id_ciclo
      		|| (this.ciclo && this.ciclo.id_ciclo)
      		|| (this.idciclo && this.idciclo.id_ciclo)

      	return this.filterSalonesDisponibles({
      		salones: this.salones,
      		idPlantel: g.id_plantel || this.plantel,
      		idCiclo,
      		idHorario: g.id_horario,
      		idSalonActual: g.id_salon,
      		grupos: this.grupos || [],
      		excludeGrupoId: g.id_grupo,
      		horariosCatalog: catalog,
      		grupoRef
      	})
      },

      filterSalones( ){

      	let salones = this.plantel
      		? this.salones.filter(el => el.id_plantel == this.plantel && el.activo_sn == 1)
      		: []

      	const COLORES_FONDOS = [
				  "#B71C1C", "#880E4F", "#4A148C", "#311B92", "#1A237E",
				  "#0D47A1", "#0B3D91", "#01579B", "#006064", "#004D40",
				  "#1B5E20", "#14532D", "#3F6212", "#7C2D12", "#BF360C",
				  "#3E2723", "#263238", "#374151", "#111827", "#134E4A"
				];

				const LETRA_ORDENAR = ["a","b","c","d","e","f","g","h","i","j","k","l","m","n","o"];

				for( const i in salones ){

					salones[i]['color'] = COLORES_FONDOS[i]
					salones[i]['letra'] = LETRA_ORDENAR[i]

				}

      	return salones
      },

      // Triangulo amarillo, bajó alumnaje

      filterRangos() {


      	let newGrupos = this.filterGrupos

      	const isTeens = s => String(s).toUpperCase().includes("TEENS");

			  // 1) Filtra por plantel y normaliza horas

			  let respuesta = this.rangos.map(r => ({ ...r }))

			  // 3) Contar por rango (solapamiento)
			  for( const i in respuesta ){

			  	const { inicio, fin } = respuesta[i]

			  	// this.gruposHorario = newGrupos.filter( el => el.id_plantel == this.plantel ).sort((a, b) => a.grupo.localeCompare(b.grupo))
			  	// Consultamos los grupos del día lunes
			  	let gruposHorario = this.gruposEnTramoPorDia(newGrupos, inicio, fin, 'lunes')

			  	let salones = this.filterSalones.map(r => ({ ...r }))

			  	// Helper seguro para strings

			  	// Sacamos los grupos que están en ese salon
			  	for( const j in salones ){

			  		const { id_salon, capacidad } = salones[j]

			  		salones[j]['selected'] = false

			  		salones[j]['name_salon'] = 'S'+ ( parseInt( j ) + 1 )

			  		let gruposSalon = gruposHorario.filter( el => el.id_salon == id_salon ).map(( registro ) => { return registro.nivel })

			  		salones[j]['grupos']  = gruposSalon

			  		let validaRelleno = false
			  		let teens         = false
			  		let bajo_alumnaje = false

			  		salones[j]['gruposCompletos'] = gruposHorario.filter( el => el.id_salon == id_salon )
			  		for( const i in salones[j]['gruposCompletos'] ){
			  			const { id_nivel, alumnos, grupo } = salones[j]['gruposCompletos'][i]
			  			if( [4,1,'4','1'].includes( id_nivel ) && alumnos <  capacidad ){
			  				validaRelleno = true
			  			}

			  			bajo_alumnaje = alumnos < 5 ? true : false
			  			teens = grupo.match('TEENS') ? true : false
			  		}
			  		salones[j]['relleno'] = validaRelleno
			  		salones[j]['teens']   = teens
			  		salones[j]['alumnos'] = gruposHorario.filter( el => el.id_salon == id_salon ).map(( registro ) => { return registro.alumnos })
			  		salones[j]['bajo_alumnaje']   = bajo_alumnaje

			  	}

			  	let prev1 = i > 0 ? respuesta[i-1]['lu11_n'][0] : null
			  	let prev2 = i > 0 ? respuesta[i-1]['lu12_n'][0] : null
			  	let prev3 = i > 0 ? respuesta[i-1]['lu13_n'][0] : null
			  	let prev4 = i > 0 ? respuesta[i-1]['lu14_n'][0] : null
			  	let prev5 = i > 0 ? respuesta[i-1]['lu15_n'][0] : null
			  	let prev6 = i > 0 ? respuesta[i-1]['lu16_n'][0] : null
			  	let prev7 = i > 0 ? respuesta[i-1]['lu17_n'][0] : null
			  	let prev8 = i > 0 ? respuesta[i-1]['lu18_n'][0] : null
			  	let prev9 = i > 0 ? respuesta[i-1]['lu19_n'][0] : null
			  	let prev10 = i > 0 ? respuesta[i-1]['lu110_n'][0] : null
			  	let prev11 = i > 0 ? respuesta[i-1]['lu111_n'][0] : null
			  	let prev12 = i > 0 ? respuesta[i-1]['lu112_n'][0] : null
			  	let prev13 = i > 0 ? respuesta[i-1]['lu113_n'][0] : null
			  	let prev14 = i > 0 ? respuesta[i-1]['lu114_n'][0] : null
			  	let salonesP1 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP2 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP3 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP4 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP5 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP6 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP7 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP8 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP9 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP10 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP11 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP12 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP13 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesP14 = salones.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))

			  	if( prev1 ){
			  		salonesP1 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev1.letra ? 0 : 1;
						    const pb = b.letra == prev1.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev2 ){

			  		// // Uso con tus variables:
						// const prevOrder = (salonesP1 || []).map(x => String(x.letra || ''));
						// var current = (salones || []).filter(function (el) {
						//   return el && el.grupos && el.grupos.length > 0;
						// });
						// const salonesP2 = this.alinPorAnterior(prevOrder, current);

			  		salonesP2 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev2.letra ? 0 : 1;
						    const pb = b.letra == prev2.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev3 ){

			  		// Uso con tus variables:
						// const prevOrder = (salonesP2 || []).map(x => String(x.letra || ''));
						// var current = (salones || []).filter(function (el) {
						//   return el && el.grupos && el.grupos.length > 0;
						// });
						// const salonesP3 = this.alinPorAnterior(prevOrder, current);

			  		salonesP3 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev3.letra ? 0 : 1;
						    const pb = b.letra == prev3.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev4 ){
			  		salonesP4 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev4.letra ? 0 : 1;
						    const pb = b.letra == prev4.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev5 ){
			  		salonesP5 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev5.letra ? 0 : 1;
						    const pb = b.letra == prev5.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev6 ){
			  		salonesP6 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev6.letra ? 0 : 1;
						    const pb = b.letra == prev6.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev7 ){
			  		salonesP7 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev7.letra ? 0 : 1;
						    const pb = b.letra == prev7.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev8 ){
			  		salonesP8 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev8.letra ? 0 : 1;
						    const pb = b.letra == prev8.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev9 ){
			  		salonesP9 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev9.letra ? 0 : 1;
						    const pb = b.letra == prev9.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev10 ){
			  		salonesP10 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev10.letra ? 0 : 1;
						    const pb = b.letra == prev10.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev11 ){
			  		salonesP11 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev11.letra ? 0 : 1;
						    const pb = b.letra == prev11.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev12 ){
			  		salonesP12 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev12.letra ? 0 : 1;
						    const pb = b.letra == prev12.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev13 ){
			  		salonesP13 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev13.letra ? 0 : 1;
						    const pb = b.letra == prev13.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prev14 ){
			  		salonesP14 = salones
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prev14.letra ? 0 : 1;
						    const pb = b.letra == prev14.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

  		  	const salonesLibresLu = salones.filter(el => !el.grupos.length).map(r => ({ ...r }))
  		  	for (let col = 1; col <= 14; col++) {
  		  		respuesta[i][`lu${col}_x`] = salonesLibresLu
  		  	}
  		  	respuesta[i]['lu1_error']  = salones.length > 1 ? true : false
  		  	
  		  	// Cada índice es un salón fijo (S1, S2, S3...). Teens no cambia de columna.
  		  	const salonesLu = salones.map(r => ({ ...r }))
  		  	respuesta[i]['lu11_n'] = salonesLu
  		  	respuesta[i]['lu12_n'] = salonesLu
  		  	respuesta[i]['lu13_n'] = salonesLu
  		  	respuesta[i]['lu14_n'] = salonesLu
  		  	respuesta[i]['lu15_n'] = salonesLu
  		  	respuesta[i]['lu16_n'] = salonesLu
  		  	respuesta[i]['lu17_n'] = salonesLu
  		  	respuesta[i]['lu18_n'] = salonesLu
  		  	respuesta[i]['lu19_n'] = salonesLu
  		  	respuesta[i]['lu110_n'] = salonesLu
  		  	respuesta[i]['lu111_n'] = salonesLu
  		  	respuesta[i]['lu112_n'] = salonesLu
  		  	respuesta[i]['lu113_n'] = salonesLu
  		  	respuesta[i]['lu114_n'] = salonesLu

  		  	/* MARTES */
  		  	const gruposHorarioMa = this.gruposEnTramoPorDia(newGrupos, inicio, fin, 'martes')

			  	let salonesMa = this.filterSalones.map(r => ({ ...r }))

			  	// Sacamos los grupos que están en ese salon
			  	for( const j in salonesMa ){

			  		const { id_salon, capacidad } = salonesMa[j]

			  		salonesMa[j]['selected'] = false

			  		salonesMa[j]['name_salon'] = 'S'+ ( parseInt( j ) + 1 )

			  		let gruposSalon = gruposHorarioMa.filter( el => el.id_salon == id_salon ).map(( registro ) => { return registro.nivel })

			  		salonesMa[j]['grupos'] = gruposSalon

			  		let validaRelleno = false
			  		let teens         = false
			  		let bajo_alumnaje = false

			  		salonesMa[j]['gruposCompletos'] = gruposHorarioMa.filter( el => el.id_salon == id_salon )
			  		for( const i in salonesMa[j]['gruposCompletos'] ){
			  			const { id_nivel, alumnos, grupo } = salonesMa[j]['gruposCompletos'][i]
			  			if( [4,1,'4','1'].includes( id_nivel ) && alumnos <  capacidad ){
			  				validaRelleno = true
			  			}
			  			bajo_alumnaje = alumnos < 5 ? true : false
			  			teens = grupo.match('TEENS') ? true : false
			  		}
			  		salonesMa[j]['relleno'] = validaRelleno
			  		salonesMa[j]['teens']   = teens
			  		salonesMa[j]['bajo_alumnaje']   = bajo_alumnaje

			  		salonesMa[j]['alumnos'] = gruposHorarioMa.filter( el => el.id_salon == id_salon ).map(( registro ) => { return registro.alumnos })

			  	}

  		  	let prevMa1 = i > 0 ? respuesta[i-1]['ma11_n'][0] : null
			  	let prevMa2 = i > 0 ? respuesta[i-1]['ma12_n'][0] : null
			  	let prevMa3 = i > 0 ? respuesta[i-1]['ma13_n'][0] : null
			  	let prevMa4 = i > 0 ? respuesta[i-1]['ma14_n'][0] : null
			  	let salonesMaP1 = salonesMa.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesMaP2 = salonesMa.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesMaP3 = salonesMa.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))
			  	let salonesMaP4 = salonesMa.filter( el => el.grupos.length ).sort((a, b) => a.salon.localeCompare(b.letra)).map(r => ({ ...r }))

			  	if( prevMa1 ){
			  		salonesMaP1 = salonesMa
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prevMa1.letra ? 0 : 1;
						    const pb = b.letra == prevMa1.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prevMa2 ){
			  		salonesMaP2 = salonesMa
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prevMa2.letra ? 0 : 1;
						    const pb = b.letra == prevMa2.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prevMa3 ){
			  		salonesMaP3 = salonesMa
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prevMa3.letra ? 0 : 1;
						    const pb = b.letra == prevMa3.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

			  	if( prevMa4 ){
			  		salonesMaP4 = salonesMa
						  .filter(el => el.grupos.length)
						  .sort((a, b) => {
						    const pa = a.letra == prevMa4.letra ? 0 : 1;
						    const pb = b.letra == prevMa4.letra ? 0 : 1;
						    return pa - pb || String(a.letra).localeCompare(String(b.letra), "es", { sensitivity: "base" });
						  });
			  	}

  		  	const salonesLibresMa = salonesMa.filter(el => !el.grupos.length)
  		  	for (let col = 1; col <= 4; col++) {
  		  		respuesta[i][`ma${col}_x`] = salonesLibresMa
  		  	}
  		  	respuesta[i]['ma1_error']  = salonesMa.length > 1 ? true : false
  		  	
  		  	const salonesMaFijos = salonesMa.map(r => ({ ...r }))
  		  	respuesta[i]['ma11_n'] = salonesMaFijos
  		  	respuesta[i]['ma12_n'] = salonesMaFijos
  		  	respuesta[i]['ma13_n'] = salonesMaFijos
  		  	respuesta[i]['ma14_n'] = salonesMaFijos

  		  	/* SABADO */
					const gruposHorarioSa = this.gruposEnTramoPorDia(newGrupos, inicio, fin, 'sabado')
					  .sort((a, b) => {
					    const pa = a.grupo.match('TEENS') ? 0 : 1;
					    const pb = b.grupo.match('TEENS') ? 0 : 1;
					    return pa - pb
					        || String(a.grupo).localeCompare(String(b.grupo), "es", { sensitivity: "base", numeric: true });
					  });


			  	let salonesSa = this.filterSalones.map(r => ({ ...r }))

			  	// Sacamos los grupos que están en ese salon
			  	for( const j in salonesSa ){

			  		const { id_salon, capacidad } = salonesSa[j]

			  		salonesSa[j]['name_salon'] = 'S'+ ( parseInt( j ) + 1 )

			  		let gruposSalon = gruposHorarioSa.filter( el => el.id_salon == id_salon ).map(( registro ) => { return registro.nivel })

			  		salonesSa[j]['grupos'] = gruposSalon

			  		let validaRelleno = false
			  		let teens         = false
			  		let bajo_alumnaje = false

			  		salonesSa[j]['gruposCompletos'] = gruposHorarioSa.filter( el => el.id_salon == id_salon )
			  		for( const i in salonesSa[j]['gruposCompletos'] ){
			  			const { id_nivel, alumnos, grupo } = salonesSa[j]['gruposCompletos'][i]
			  			if( [4,1,'4','1'].includes( id_nivel ) && alumnos <  capacidad ){
			  				validaRelleno = true
			  			}
			  			bajo_alumnaje = alumnos < 5 ? true : false
			  			teens = grupo.match('TEENS') ? true : false
			  		}
			  		salonesSa[j]['relleno'] = validaRelleno
			  		salonesSa[j]['teens']   = teens
			  		salonesSa[j]['bajo_alumnaje']   = bajo_alumnaje


			  		salonesSa[j]['alumnos'] = gruposHorarioSa.filter( el => el.id_salon == id_salon ).map(( registro ) => { return registro.alumnos })

			  	}

  		  	respuesta[i]['sa1_n'] = salonesSa.map(r => ({ ...r }))


  		  	/* DOMINGO */
  		  	const gruposHorarioDo = this.gruposEnTramoPorDia(newGrupos, inicio, fin, 'domingo')
					  .sort((a, b) => {
					    const pa = isTeens(a.grupo) ? 0 : 1;
					    const pb = isTeens(b.grupo) ? 0 : 1;
					    return pa - pb
					        || String(a.grupo).localeCompare(String(b.grupo), "es", { sensitivity: "base", numeric: true });
					  });

			  	let salonesDo = this.filterSalones.map(r => ({ ...r }))

			  	// Sacamos los grupos que están en ese salon
			  	for( const j in salonesDo ){

			  		const { id_salon, capacidad } = salonesDo[j]

			  		salonesDo[j]['name_salon'] = 'S'+ ( parseInt( j ) + 1 )

			  		let gruposSalon = gruposHorarioDo.filter( el => el.id_salon == id_salon ).map(( registro ) => { return registro.nivel })

			  		salonesDo[j]['grupos'] = gruposSalon

			  		let validaRelleno = false
			  		let teens         = false
			  		let bajo_alumnaje = false


			  		salonesDo[j]['gruposCompletos'] = gruposHorarioDo.filter( el => el.id_salon == id_salon )
			  		for( const i in salonesDo[j]['gruposCompletos'] ){
			  			const { id_nivel, alumnos, grupo } = salonesDo[j]['gruposCompletos'][i]
			  			if( [4,1,'4','1'].includes( id_nivel ) && alumnos <  capacidad ){
			  				validaRelleno = true
			  			}

			  			bajo_alumnaje = alumnos < 5 ? true : false
			  			teens = grupo.match('TEENS') ? true : false
			  		}
			  		salonesDo[j]['relleno'] = validaRelleno
			  		salonesDo[j]['teens']   = teens
			  		salonesDo[j]['bajo_alumnaje']   = bajo_alumnaje


			  		salonesDo[j]['alumnos'] = gruposHorarioDo.filter( el => el.id_salon == id_salon ).map(( registro ) => { return registro.alumnos })

			  	}

  		  	respuesta[i]['do1_n'] = salonesDo.map(r => ({ ...r }))



			  }

			  return respuesta
			},

      filterPlanteles( ){

      	if( this.escuela == 1){

      		return this.planteles.filter( el => el.plantel.match('FAST') )

      	}else{

      		return this.planteles.filter( el => !el.plantel.match('FAST') )

      	}

      }
    },

    watch: {
      // Consultar cuando haya un cambio en el ciclo y este sea un ciclo seleccionado y no un ciclo vacio
      ciclo () { if(this.ciclo){ this.consultar() } },

      tabs( val ) { console.log( val ) },

    },

    async created () {

    	// Mandar a llamar todo a la vez
      await Promise.all([
		    this.initialize(),
		    this.getPlanteles(),
		    this.getSalones(),
		    this.getHorariosCatalog()
		  ])
    },

    methods: {
      gruposEnTramoPorDia (grupos, inicio, fin, diaCampo) {
      	return grupos
      		.filter(el => {
      			const g = this.normalizarGrupoDias(el)
      			return el.id_plantel == this.plantel &&
      				g[diaCampo] &&
      				this.grupoEnTramoHorario(el, inicio, fin)
      		})
      		.sort((a, b) => a.grupo.localeCompare(b.grupo))
      },

      async getHorariosCatalog () {
      	try {
      		const response = await this.$http.get('horarios.activos')
      		this.horariosCatalog = response.data || []
      	} catch (error) {
      		const msg = (error && error.response && error.response.data && error.response.data.message)
      			? error.response.data.message
      			: 'Error al obtener horarios'
      		this.validarError(msg)
      	}
      },
      // Funcion para cargar datos iniciales
      initialize () {
      	this.cargar = true
        // Vaciar los ciclos
        this.ciclos = []
        // Obtener todos los ciclos
        this.$http.get('roles.ciclos.all').then(response=>{
          // hacer un ciclo ya que los ciclos vienen varios como inscripciones y todo eso
          // y solo queremos los ciclos que en su nombre dicen ciclo
          for(const i in response.data){
            //  si es diferente a FE
            if (!(response.data[i].ciclo.search('FE') != -1)) {
              // Y es igual a FE, se agrega a ciclos
              // por qué es diferente a FE? por que es por estetica, mostrar solo los ciclos normales, ya que los ciclos tienen ligado el ciclo FE
              if(response.data[i].ciclo.search('CICLO') != -1){
                this.ciclos.push(response.data[i])
              }
            }
          }
      		this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      async getPlanteles () {
			  this.cargar = true
			  this.planteles = []

			  try {
			    const response = await this.$http.get('planteles.oficiales')
			    this.planteles = response.data.filter( el => el.deleted == 0 && el.zona != 0 )

			    this.planteles = this.planteles.sort((a, b) => a.plantel.localeCompare(b.plantel));
			  } catch (error) {
			    const msg = (error && error.response && error.response.data && error.response.data.message)
    								? error.response.data.message
    								: 'Error al obtener planteles'
  				this.validarError(msg)
			  } finally {
			    this.cargar = false
			  }
			},


			alinPorAnterior(prevOrder, current, key = x => String(x.letra)) {
		  // prevOrder: ['S1','S3','S9'] tomado de la línea anterior (solo las letras/ids)
		  // current:   objetos actuales con { letra, ... }
		  const pos = new Map(prevOrder.map((v, i) => [String(v), i]));
		  const out = Array(prevOrder.length).fill(null);

		  // Coloca en su MISMO índice lo que siga existiendo
		  const rest = [];
		  for (const item of current) {
		    const k = key(item);
		    if (pos.has(k) && out[pos.get(k)] === null) out[pos.get(k)] = item;
		    else rest.push(item);
		  }

		  // Ordena lo que sobra y rellena huecos de izq. a der.
		  rest.sort((a, b) => key(a).localeCompare(key(b), "es", { sensitivity: "base" }));
		  let r = 0;
		  for (let i = 0; i < out.length && r < rest.length; i++) {
		    if (out[i] === null) out[i] = rest[r++];
		  }
		  // Si aún sobra, va al final
		  while (r < rest.length) out.push(rest[r++]);

		  return out; // conserva huecos (null) si no se llenaron
		},

			async getSalones () {
			  this.cargar = true
			  this.salones = []

			  try {
			    const response = await this.$http.get('salones.activos')
			    this.salones = response.data

			  } catch (error) {
			    const msg = (error && error.response && error.response.data && error.response.data.message)
    								? error.response.data.message
    								: 'Error al obtener salones'
  				this.validarError(msg)
			  } finally {
			    this.cargar = false
			  }
			},

			async consultar () {
      	
      	this.generarHorariosMarcas( )

      	if( !this.ciclo ){
      		return this.validarErrorDirecto('Selecciona un ciclo por favor')
      	}

      	const idCiclo = this.escuela == 0
      		? this.ciclo.id_ciclo
      		: (this.ciclo.id_ciclo_relacionado || this.ciclo.id_ciclo)

      	if (!idCiclo) {
      		return this.validarErrorDirecto('El ciclo seleccionado no tiene id válido')
      	}
			  

			  this.cargar = true
			  this.grupos = []
        
        let payload = {
        	id_ciclo: idCiclo,
        	escuela: this.escuela
        }

			  try {
			    const response = await this.$http.post('grupos.list', payload)
			    this.grupos = (response.data || []).filter(el => {
			    	if (!el || el.activo_sn != 1) return false
			    	const nombre = String(el.grupo || '')
			    	return !nombre.match('APOYO') && !nombre.match('CERTI')
			    })



			  } catch (error) {
			    let msg = 'Error al obtener los grupos'
			    if (error && error.response && error.response.data) {
			    	const d = error.response.data.message
			    	msg = typeof d === 'string' ? d : String(d || msg)
			    }
  				this.validarError(msg)
			  } finally {
			    this.cargar = false
			  }
			},

			generarHorariosMarcas({
			  start = '08:00',
			  end = '21:00',
			  gapStart = '12:00',
			  gapEnd = '16:00',
			  step = 30
			} = {}) {
			  const s  = this.toMin(start)
			  const e  = this.toMin(end)
			  const gs = this.toMin(gapStart)
			  const ge = this.toMin(gapEnd)

			  const tramos = []
			  for (let t = s; t < e; t += step) {
			    // Omitir tramos cuyo INICIO cae dentro del hueco [gs, ge)
			    // if (t >= gs && t < ge) continue

			    const inicio = this.toHHMM(t)
			    const finMin = Math.min(t + step, e)
			    const fin    = this.toHHMM(finMin)

			    tramos.push({
			      inicio,              // "08:00"
			      fin,                 // "08:30"
			      label: `${inicio} a ${fin}` // "08:00 a 08:30"
			    })
			  }

			  this.rangos = tramos
			},

			// Helpers
			// Utilidad: "HH:MM:SS" → minutos
			toMin ( t ) {
			  if (t instanceof Date) return t.getHours()*60 + t.getMinutes();
			  const [hh, mm, ss="0"] = String(t).split(":").map(Number);
			  return hh*60 + mm + (ss/60);
			},

			toHHMM (min)  {
			  const h = Math.floor(min / 60)
			  const m = min % 60
			  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00`
			},

			normalizeTime(str) {
			  const [h='00', m='00'] = String(str).split(':')
  			return `${h.padStart(2,'0')}:${m.padStart(2,'0')}`
			},

			abrirDialogGrupo ( salon ){

				this.salon = Object.assign({}, salon)

				this.dialogGrupos = true

			},

			// máximo de chips en ese renglón considerando todas las columnas/días
	    maxChips(item) {
	      return this.dias.reduce((m, k) => Math.max(m, (item[k] || []).length), 0);
	    },
	    // rellena con null hasta 'len' para dibujar placeholders
	    pad(arr, len) {
	      return Array.from({ length: len }, (_, i) => arr[i] || null);
	    },

	    salonLibreEnColumna (salon, salonesColumna, indice) {
	      const propio = salonesColumna && salonesColumna[indice]
	      if (!propio || (propio.grupos && propio.grupos.length)) return false
	      return salon.id_salon == propio.id_salon
	    },

	    toggleSalonSelect (salon, item, dia) {
	      if (this.soloLecturaPlaneacion) return
	      salon.selected = !salon.selected
	      this.addSalonSelect(salon, item, dia)
	    },

	    addSalonSelect(salon, item, dia) {
			  const inicio = String(item.inicio);

			  const idx = this.gruposSeleccionados.findIndex(el =>
			    el.id_salon === salon.id_salon &&
			    el.dia === dia &&
			    String(el.inicio) === inicio
			  );

			  if (idx !== -1) {
			    this.gruposSeleccionados.splice(idx, 1);
			  } else {
			    this.gruposSeleccionados.push({
			      ...salon,
			      dia,
			      inicio,
			      fin: item.fin,
			      label: item.label,
			      id_plantel: this.plantel,
			      id_ciclo: this.ciclo ? this.ciclo.id_ciclo : null,
			    });
			  }
			},

			guardarGruposPlaneacion () {
			  if (this.$refs.gruposMultiples) {
			    this.$refs.gruposMultiples.save()
			  }
			},

			onGruposGuardados () {
			  this.gruposSeleccionados = []
			  this.dialogGrupos = false
			  this.consultar()
			},

			cerrarGrupo( salon , i ){
				if (this.soloLecturaPlaneacion) return
				this.grupoACerrar = Object.assign({}, salon.gruposCompletos[0])
				this.salonCierreOriginal = this.grupoACerrar.id_salon
				this.dialoCerrar = true
			},

			async confirmarCierre () {
			  this.cargar = true

			  try {
			  	if (this.grupoACerrar.id_salon && this.salonCierreOriginal != this.grupoACerrar.id_salon) {
			  		await this.$http.post('grupos.update.salon', {
			  			id_grupo: this.grupoACerrar.id_grupo,
			  			id_salon: this.grupoACerrar.id_salon
			  		})
			  	}

			    await this.$http.post('cerrar.grupos', this.grupoACerrar)

					this.dialoCerrar = false
			    this.consultar( )
			  
			  } catch (error) {
			    const msg = (error && error.response && error.response.data && error.response.data.message)
    								? error.response.data.message
    								: 'Error al guardar grupo'
  				this.validarError(msg)
			  } finally {
			    this.cargar = false
			  }
			},

    },
  }

</script>
<style scoped>

  .stack { display: flex; flex-direction: column; gap: 0px; }
.chip-uni { width: 100%; min-height: 36px; border-radius: 18px; }

  .chip-col{
	  display: grid;
	  grid-template-rows: repeat(var(--rows), 28px);
	  row-gap: 6px;
	}
	.chip-placeholder{
	  height: 28px;
	  visibility: hidden; /* reserva espacio sin verse */
	}

  .v-data-table__wrapper::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-data-table__wrapper::-webkit-scrollbar:vertical {
    width: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar:vertical{
    width: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar-button:increment,.v-data-table__wrapper::-webkit-scrollbar-button{
    display: none;
  }

  .v-data-table__wrapper::-webkit-scrollbar:horizontal{
    height: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  #clasesGrupos td:nth-child(2) {
    background-color: #E8E8E8 !important;
  }

  #clasesGrupos td:nth-child(4) {
    background-color: #E8E8E8 !important;
  }

  #clasesGrupos td:nth-child(6) {
    background-color: #E1BEE7 !important;
  }

  #clasesGrupos td:nth-child(8) {
    background-color: #E1BEE7 !important;
  }

  #clasesGrupos td:nth-child(10) {
    background-color: #E1BEE7 !important;
  }

  #clasesGrupos td:nth-child(12) {
    background-color: #E1BEE7 !important;
  }

  #clasesGrupos td:nth-child(14) {
    background-color: #E8E8E8 !important;
  }

  #clasesGrupos td:nth-child(16) {
    background-color: #E8E8E8 !important;
  }

  #clasesGrupos td:nth-child(18) {
    background-color: #E8E8E8 !important;
  }

  #clasesGrupos td:nth-child(20) {
    background-color: #E8E8E8 !important;
  }

  /* quita padding del <td> y estira el chip */
	#clasesGrupos td { padding: 0 !important; }
	.cell-fill { width: 100%; }
	.chip-full {
	  display: block;         /* ocupa ancho completo */
	  width: 100%;
	  margin: 0;              /* sin márgenes para pegar a bordes */
	  justify-content: center;
	  border-radius: 9999px;  /* como "block" de Vuetify, pero más consistente */
	}


	#clasesGrupos {
	  --slot-h: 48px;               /* altura por fila/slot */
	}

	#clasesGrupos .v-data-table__wrapper table { border-collapse: collapse; }
	#clasesGrupos tbody > tr { height: var(--slot-h); }          /* fija la altura de la fila */
	#clasesGrupos td { padding: 0 !important; }                  /* sin padding en celdas */

	#clasesGrupos .cell-full { height: 100%; }                   /* contenedor a 100% */
	#clasesGrupos .chip-fill {
	  display: flex;
	  width: 100%;
	  height: 100%;                                              /* el chip ocupa toda la celda */
	  margin: 0 !important;
	  border-radius: 10px;                                       /* opcional: forma de pastilla */
	  align-items: center;
	  justify-content: center;
	}

	.chips-container {
	  height: 100%;
	  display: flex;
	  margin: 0 !important;
	  flex-wrap: nowrap;     /* que no bajen de línea */
	  overflow-x: auto;      /* scroll si no caben */
	  white-space: nowrap;
	}

	.full-chip {
	  display: flex;          /* para centrar el texto verticalmente */
	  align-items: center;
	  height: 100% !important;           /* <-- ocupa todo el alto del renglón */
	  min-height: 0 !important;   /* anula límites si los hubiera */
	  flex: 0 0 176px;
	  width: 176px;
	  max-width: 176px;
	  overflow: hidden;
	  box-sizing: border-box;
	  white-space: nowrap;    /* texto en una sola línea */
	  padding: 0 8px;
	  border-radius: 4px !important;
	}

	.salon-slot-vacio {
	  flex: 0 0 176px;
	  width: 176px;
	  height: 100%;
	  visibility: hidden;
	}

</style>